/* eslint-disable no-restricted-syntax */

/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import { Link, Typography2 } from '@coursera/cds-core';

import { TrackedLink2 } from 'bundles/page/components/TrackedLink2';
import getProductTitle from 'bundles/unified-common/utils/getProductTitle';
import Modal from 'bundles/unified-description-page-common/components/shared/modals/Modal';
import type { ModalProps } from 'bundles/unified-description-page-common/components/shared/modals/Modal';
import { usePageInfo } from 'bundles/unified-description-page-common/contexts/PageInfoContext';
import type { SpecializationFragment } from 'bundles/unified-description-page-common/queries/bff/__generated__/SharedCourseEntitiesFragments';

import _t from 'i18n!nls/xdp';

const styles = {
  titleDivider: () => css`
    border-bottom: 2px solid var(--cds-color-grey-50);
  `,
  linkContainer: () => css`
    border-bottom: 2px solid var(--cds-color-grey-50);
    padding: var(--cds-spacing-200) 0;
  `,
  specializationLink: () => css`
    text-decoration-color: var(--cds-color-grey-975);
  `,
  specializationLinkText: css`
    font-weight: 600;
  `,
};

type Props = ModalProps & {
  specializations: Array<SpecializationFragment>;
};

const MultipleSpecializationsModal = ({ specializations, ...rest }: Props) => {
  const { getSpecializationLink } = usePageInfo();
  return (
    <Modal {...rest} header={_t('This course is part of multiple programs')}>
      <div css={styles.titleDivider} />
      {specializations.map((specialization) => (
        <div css={styles.linkContainer}>
          <Link
            component={TrackedLink2}
            href={getSpecializationLink({
              productSlug: specialization.slug,
              productVariant: specialization.productVariant,
            })}
            trackingName="hero_program_modal_link"
            typographyVariant="bodyPrimary"
            target="_blank"
            css={styles.specializationLink}
          >
            <Typography2 component="span" variant="bodyPrimary" css={styles.specializationLinkText}>
              {getProductTitle(specialization.name, specialization.productVariant)}
            </Typography2>
          </Link>
        </div>
      ))}
    </Modal>
  );
};

export default MultipleSpecializationsModal;
